import React, { useContext, useEffect, useState } from 'react';
import { Badge, Button, Container, Image } from "react-bootstrap"
import { Link, useNavigate } from "react-router-dom"
import FavoriteIcon from "../FavoriteIcon"
import * as Icon from 'react-bootstrap-icons';
import ApiFetch from "../ApiFetch";
import { LanguageCtx, LoginInfo } from '../../App';
import FollowButton from '../FollowButton';
import UserInfoPopup from './UserInfoPopup';
import { useTranslation } from "react-i18next";
import ImageViewPopup from '../ImageViewPopup';
import { rankingBgColor,rankingOpacity } from "./RankingUtil";
import EventViewPopup from '../EventViewPopup';
import UserMark from '../UserMark';
import TextViewPopup from '../TextViewPopup';
import { imgPath } from '../../service/CommonUtil';
import VideoViewPopup from '../VideoViewPopup';
import UserAvatarWithLikes from '../UserAvatarWithLikes';
import { Box, Chip, Dialog, DialogContent, Grid, IconButton, Typography } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import CharacterViewPopup from '../CharacterViewPopup';
import FavoriteIconMui from '@mui/icons-material/Favorite';

const Thumb = (props) => {
    async function getUserInfo(userIdOrDisplayId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/"+userIdOrDisplayId)
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t,i18n} = useTranslation()
    // ナビゲート
    const navigate = useNavigate()
    let data = props.data
    let i = props.i
    let dialog = props.dialog
    let observer = props.observer
    let userInfoHidden = props.userInfoHidden
    let onAddPress = props.onAddPress
    let onDeletePress = props.onDeletePress
    let type = props.type || "image"
    let from = props.from || ""
    let rank = props.rank
    useEffect(() => {
        if(observer !== undefined){
            let lazys = document.querySelectorAll("."+(from === "popup" ? "lazy-popup" : "lazy"))
            let elm = lazys[lazys.length - 1];
            if(elm.dataset.lazy !== "1"){
                observer.observe(elm)
                elm.dataset.lazy = "1"
            }
            /*document.querySelectorAll(".lazy").forEach(e => {
                if(e.dataset.lazy !== "1"){
                    observer.observe(e)
                    e.dataset.lazy = "1"
                }
            })*/
        }
    })
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    const [displayId,setDisplayId] = useState()
    const [selfIntroduction,setSelfIntroduction] = useState()
    const [follow,setFollow] = useState()
    const [follower,setFollower] = useState()
    const [isFollow,setIsFollow] = useState()
    const [showViewPopup,setShowViewPopup] = useState(false)
    const random = Math.random() * 100000
    const [title,setTitle] = useState("")
    function clearAllInterval(){
        for (var i = 1; i < 99999; i++)
            window.clearInterval(i)
    }
    // 言語設定
    const {language,setLanguage} = useContext(LanguageCtx)
    useEffect(() => {
        if(language === "ja"){
            setTitle(data.title)
        } else if(language === "en"){
            if(data.title_en && data.title_en.length > 0){
                setTitle(data.title_en)
            } else {
                setTitle(data.title)
            }
        }
    },[language,data])
    function imageUrl(data,type){
        if(type === "video"){
            if(data.status >= 4){
                return ApiFetch.API_PROTOCOL+'//'+(type === "video" ? ApiFetch.VIDEO_HOST : ApiFetch.IMG_HOST) + imgPath(type) + '/post/t/'+(data.group_id)+"_in"+ApiFetch.API_THUMB_EXT
            } else {
                return ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST + imgPath(type) + '/encode.webp'
            }
        } else {
            return ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST + imgPath(type) + '/post/t/'+(data.group_id)+"_in"+ApiFetch.API_THUMB_EXT
        }
    }
    const [time,setTime] = useState(0)
    return (
        <Container style={{position:"relative",width:"180px"}} className={"p-0" + (!(data.age_limit === 1) ? " not-all-ages " : " ") + (data.mute === 1 ? " mute" : "")}
        onMouseDownCapture={() => {
            setTime(new Date().getTime())
        }}
        onMouseOver={() => {
            document.querySelectorAll("."+from+"thumb-img-"+i).forEach(elm => {
                elm.style.scale = "1.1"
                elm.style.transition = "0.3s"
            })
            setInterval(() => {
                if(type === "video" && data.status >= 4){
                    document.querySelector("."+from+"thumb-img-"+i).src = ApiFetch.API_PROTOCOL+'//'+ApiFetch.VIDEO_HOST + imgPath(type) + '/post/t/'+(data.group_id)+"_digest"+ApiFetch.API_THUMB_EXT
                    clearAllInterval()
                }
            },500)
        }}
        onMouseLeave={() => {
            document.querySelectorAll("."+from+"thumb-img-"+i).forEach(elm => {
                elm.style.scale = "1"
                elm.style.transition = "0.3s"
            })
            if(type === "video" && data.status >= 4){
                document.querySelector("."+from+"thumb-img-"+i).src = ApiFetch.API_PROTOCOL+'//'+ApiFetch.VIDEO_HOST + imgPath(type) + '/post/t/'+(data.group_id)+"_in"+ApiFetch.API_THUMB_EXT
                clearAllInterval()
            }
        }}
        >
            {type === "character" && showViewPopup ? <CharacterViewPopup groupId={data.group_id} detailId={data.id} switch={setShowViewPopup} i={i} list={props.list} listName={props.listName} /> : ""}
            {type === "image" && showViewPopup ? <ImageViewPopup groupId={data.group_id} detailId={data.id} switch={setShowViewPopup} i={i} list={props.list} listName={props.listName} /> : ""}
            {type === "video" && showViewPopup ? <VideoViewPopup groupId={data.group_id} detailId={data.id} switch={setShowViewPopup} i={i} list={props.list} listName={props.listName} /> : ""}
            {type === "text" && showViewPopup ? <TextViewPopup groupId={data.group_id} detailId={data.id} switch={setShowViewPopup} i={i} list={props.list} listName={props.listName} /> : ""}
            {type === "event" && showViewPopup ? <EventViewPopup groupId={data.group_id} detailId={data.id} switch={setShowViewPopup} i={i} list={props.list} listName={props.listName} /> : ""}
            <a href={"/"+type+"/"+data.group_id} className='d-none'>link</a>
            <div className="cp_ribbon05" style={{display:rank !== undefined && rank < 3 ? "block" : "none",cursor:"pointer"}}
            onClick={(e) => {
                if(props.init){
                    props.init()
                }
                if(props.isLink){
                    //window.location.href = "/"+type+"/"+data.group_id
                    navigate("/"+type+"/"+data.group_id)
                    return
                }
                if(props.onClick === undefined){
                    setShowViewPopup(true)
                } else {
                    props.onClick()
                }
            }}
            >
                <div className="cp_ribbon">TOP 3</div>
            </div>
            <Container  className="p-0 mb-3" key={i}>
            <Container style={{position:"relative",width:"180px",height:"180px",padding:0,overflow:"hidden"}}>
                    {data.character_list !== undefined && data.character_list.length > 0 ?
                    (<div style={{position:"absolute",bottom:"55px",right:"10px",zIndex:2}}>
                        {data.character_list.filter(d => d.user_id === data.user_id).length === data.character_list.length ? <Chip label={<>公式</>} style={{fontSize:"10px",backgroundColor:"pink"}} size='small' /> :
                        <Chip label={<><FavoriteIconMui style={{color:"red",fontSize:"10px"}} /> ファンアート</>} style={{fontSize:"10px",backgroundColor:"pink"}} size='small' />}
                    </div>) : ""}
                    <div style={{position:"absolute",top:"20px",right:"10px",zIndex:2,display:props.shienLabelDisp !== false && data.limit_div !== undefined && data.limit_div !== "public" ? "block" : "none"}}>
                        <Chip color="warning" label={<>メンバー限定{data.unit_amount > 0 ? "＋" : " "}</>} style={{fontSize:"12px"}} size='small' />
                    </div>
                    <div style={{position:"absolute",top:"20px",right:"10px",zIndex:2,display:props.shienLabelDisp !== false && data.limit_div !== undefined && data.limit_div === "public"
                        && data.unit_amount > 0 ? "block" : "none"}}>
                        <Chip color="warning" label="単品販売" style={{fontSize:"12px"}} size='small' />
                    </div>
                    <Badge bg="secondary" style={{position:"absolute",bottom:"20px",left:"70px",zIndex:2,display:data.find_prompt !== undefined && data.find_prompt === 1 ? "block" : "none"}}>
                        <Icon.PSquareFill />
                    </Badge>
                    <Badge bg="secondary" style={{position:"absolute",zIndex:"1",top:"20px",left:"20px",display:data.age_limit === 2 ? "block":"none"}}>
                        PG-12
                    </Badge>
                    <Badge bg="secondary" style={{position:"absolute",zIndex:"1",top:"20px",left:"20px",display:data.age_limit === 3 ? "block":"none"}}>
                        R-15
                    </Badge>
                    <Badge bg="secondary" style={{position:"absolute",zIndex:"1",top:"20px",left:"20px",display:data.age_limit === 4 ? "block":"none"}}>
                        R-18
                    </Badge>
                    <Badge bg="secondary" style={{position:"absolute",zIndex:"1",top:"20px",left:"20px",display:data.age_limit === 5 ? "block":"none"}}>
                        R-18G
                    </Badge>
                    <Badge bg="secondary" style={{position:"absolute",zIndex:"1",bottom:"20px",left:"20px",display:data.img_count > 1 ? "block":"none"}}>
                        <Icon.CollectionFill /> {data.img_count}
                    </Badge>
                    <Badge bg="primary" style={{position:"absolute",zIndex:2,top:"8px",left:"10px",display:data.question_id && data.question_id.length > 0 ? "block":"none"}}>
                        投票あり
                    </Badge>
                    {data.rank !== undefined ? (
                    <div>
                        <div className='text-center' style={{position:"absolute",backgroundColor:rankingBgColor(data.rank),opacity:rankingOpacity(data.rank),width:"40px",height:"40px",zIndex:"1",top:"10px",left:"10px",fontWeight:"bold",fontSize:"24px"}} />
                        <div className='text-center' style={{position:"absolute",color:"#FFFFFF",width:"40px",height:"40px",zIndex:"1",top:"10px",left:"10px",fontWeight:"bold",fontSize:"24px"}}>
                            {data.rank}
                        </div>
                    </div>
                    ) : ""}
                    <Badge bg="secondary" title={t("common.limited")} style={{cursor:"pointer",position:"absolute",padding:"3px",zIndex:1,bottom:"20px",right:"50px",display:data.limited_publication === 1 ? "block":"none"}}>
                        <Icon.EyeFill style={{color:"#FFFFFF",fontSize:"16px"}} />
                    </Badge>
                    {(data.limit_div !== "public" && data.plan_access === 0 || data.unit_amount > 0 && data.is_purchased === 0) ? <LockIcon style={{fontSize:"28px",cursor:"pointer",position:"absolute",zIndex:"1",bottom:"80px",right:"74px"}} onClick={() =>{
                        if(new Date().getTime() - time < 150){
                            if(props.isLink){
                                //window.location.href = "/"+type+"/"+data.group_id
                                navigate("/"+type+"/"+data.group_id)
                                return
                            }
                            if(props.onClick === undefined){
                                setShowViewPopup(true)
                            } else {
                                props.onClick()
                            }
                        }
                    }} /> : ""}
                    <FavoriteIcon style={{fontSize:"18px",cursor:"pointer",position:"absolute",zIndex:"1",bottom:"20px",right:"20px"}} type={type} id={data.group_id} favorite={data.favorite} dialog={dialog} count={data.favorite_count} />
                    {/*<Link to={"/image/"+(data.group_id)}>*/}
                        <Image data-type={props.dataType === undefined ? "" : props.dataType} data-no={i} loading="lazy" src={imageUrl(data,type)+"?"+data.img_hash}
                        style={{filter:(
                            loginInfo.pg12_display_flag === 2 && data.age_limit === 2
                            || loginInfo.r15_display_flag === 2 && data.age_limit === 3
                            || loginInfo.r18_display_flag === 2 && data.age_limit === 4
                            || loginInfo.r18g_display_flag === 2 && data.age_limit === 5
                        ) || data.age_limit === 5 || data.sensitive_flag === 1 || data.sensitive_flag === 2 /*|| (data.limit_div !== "public" && data.plan_access === 0 || data.unit_amount > 0 && data.is_purchased === 0)*/ ? "blur(7px)" : "none",objectFit:"cover",position:"absolute",width:"100%",height:"100%",cursor:"pointer"}} className={"p-1 "+(from==="popup"?"lazy-popup":"lazy")+" "+from+"thumb-img-"+i}
                        onClick={() => {
                                if(new Date().getTime() - time < 150){
                                    if(props.isLink){
                                        //window.location.href = "/"+type+"/"+data.group_id
                                        navigate("/"+type+"/"+data.group_id)
                                        return
                                    }
                                    if(props.onClick === undefined){
                                        setShowViewPopup(true)
                                    } else {
                                        props.onClick()
                                    }
                                }
                            }}
                        onContextMenu={(e) => e.preventDefault()}
                        />
                    {/*</Link>*/}
                    <Button variant="secondary"
                    onClick={() => onAddPress(data)}
                    style={{position:"absolute",zIndex:"1",bottom:"20px",left:"20px",display:onAddPress !== undefined ? "block":"none"}}>
                        {t("common.add")}
                    </Button>
                    <Button variant="secondary"
                    onClick={() => onDeletePress(data)}
                    style={{position:"absolute",zIndex:"1",bottom:"20px",left:"20px",display:onDeletePress !== undefined ? "block":"none"}}>
                        {t("common.deleteStr")}
                    </Button>
                </Container>
                <Container style={{fontWeight:"bold",fontSize:"15px",whiteSpace:"nowrap",overflow:"hidden"}}>
                    {/*<Link to={"/image/"+(data.group_id)} style={{color:"#555555",textDecoration:"none"}}>{data.title}</Link>*/}
                    <span onClick={() => {
                                if(props.isLink){
                                    //window.location.href = "/"+type+"/"+data.group_id
                                    navigate("/"+type+"/"+data.group_id)
                                    return
                                }
                                if(props.onClick === undefined){
                                    setShowViewPopup(true)
                                } else {
                                    props.onClick()
                                }
                            }} style={{textDecoration:"none",cursor:"pointer"}}>{title}</span>
                </Container>
                {userInfoHidden === undefined || !userInfoHidden ? (
                    <>
                    <Container style={{whiteSpace:"nowrap",overflow:"hidden"}}>
                        <Link to={"/user/"+(data.display_id !== undefined && data.display_id !== "" ? data.display_id : data.user_id)} style={{color:"#555555",textDecoration:"none",cursor:"pointer"}}
                        onMouseOver={(e) => {
                            if(data.user_id !== "anonymous")
                            setInterval(() => {
                                getUserInfo(data.user_id).then(r => {
                                    let elm = document.getElementById("sub-"+random)
                                    if(elm){
                                        elm.style.display = "block"
                                    }
                                    setDisplayId(r.display_id)
                                    setSelfIntroduction(r.self_introduction)
                                    setFollow(r.follow)
                                    setFollower(r.follower)
                                    setIsFollow(r.isFollow)
                                    clearAllInterval()
                                    
                                })
                            },500)
                        }}
                        onMouseLeave={() => {
                            clearAllInterval()
                        }}
                        >
                            <UserAvatarWithLikes 
                                userId={data.user_id}
                                userDisplayId={data.display_id}
                                userName={data.user_name}
                                hash={data.hash}
                                size={24}
                                borderRadius="12px"
                                style={{marginRight: "5px", verticalAlign: "middle"}}
                                showLikes={false}
                                linkToProfile={false}
                            />
                            <ruby> {data.user_name && data.user_name.length > 8 ? data.user_name.substr(0,8) + "…" : data.user_name} <rp>(</rp><rt>{data.user_name_kana && data.user_name_kana.length > 8 ? data.user_name_kana.substr(0,8) + "…" : data.user_name_kana}</rt><rp>)</rp> </ruby>
                            <UserMark sms_auth={data.sms_auth} role={data.role} plan={data.plan} creator={data.certified_creator === 1} beginner={data.beginner} moderator_badge_display_flag={data.moderator_badge_display_flag} dialog={dialog} />
                            &nbsp;{data.isFollowed === 1 ? <span style={{fontSize:"12px",color:"#555555",backgroundColor:"#DDDDDD",borderRadius:"5px",padding:"2px"}}>フォローされています</span> : ""}
                        </Link>
                    </Container>
                    <UserInfoPopup data={data} displayId={displayId} selfIntroduction={selfIntroduction} isFollow={isFollow} follow={follow} follower={follower} random={random} dialog={dialog} />
                </>
                ) : ""}
            </Container>
        </Container>
    )
}
export default Thumb